import React, { useState } from "react"
import PropTypes from "prop-types"
import { Tag, Avatar, Button, Flex, Card } from "antd"
import { EllipsisOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import IconWithBg from "ui/IconWithBg"
import CustomDrawer from "ui/Drawer"
import { EditIcon, TrashIcon } from "icons"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import { Text } from "ui/Typography"

const CrewMobileCardList = ({ data, handleEdit, handleActivate, handleDeactivate, handleDelete }) => {
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false)
  const [selectedCrew, setSelectedCrew] = useState(null)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const openDrawerFilter = (crew) => {
    setOpenFilterDrawer(true)
    setSelectedCrew(crew)
  }

  return (
    <Flex vertical gap={16}>
      {data.map((crew) => (
        <Card className={styles.card} key={crew.id} onClick={() => navigate(routes.guideCrewMemberDetailsPath({ id: crew.id }))} style={{ cursor: "pointer" }}>
          <Flex gap={10} align="center">
            <div className="flex-1">
              <Flex align="flex-start" gap={16}>
                <Avatar src={crew.image} size={65} />
                <Flex vertical style={{ flex: 1, minWidth: 0 }}>
                  <Flex align="center" gap={8} wrap className={styles.nameRow}>
                    <span className={styles.name}>{crew.name}</span>
                    <Flex gap={8}>
                      {crew.status && (
                        <Tag color={crew.status === "active" ? "green" : "red"} className={styles.commonTag}>
                          {crew.status}
                        </Tag>
                      )}
                      {crew?.role && (
                        <Tag color="blue" className={styles.commonTag}>
                          {crew?.role}
                        </Tag>
                      )}
                    </Flex>
                  </Flex>
                  <Flex align="center" gap={8} style={{ color: "var(--color-text-secondary-dark)", fontSize: "0.98rem", marginTop: 2 }}>
                    {crew?.title && (
                      <>
                        <Text type="secondary">{crew?.title}</Text>
                        <span className={styles.dot} />
                      </>
                    )}
                    <Text type="secondary">{crew.phoneNumber}</Text>
                  </Flex>
                </Flex>
              </Flex>
              <Flex justify="space-between" className={`mt-s ${styles.detailsRow}`}>
                <Flex gap={5} className="w-full">
                  <Text type="secondary" block className={styles.label}>
                    Assigned to:
                  </Text>
                  <Text className={styles.value}>{crew.assignedTo} experiences</Text>
                </Flex>
                <Flex gap={5} className="w-full">
                  <Text type="secondary" block className={styles.label}>
                    Upcoming:
                  </Text>
                  <Text className={styles.value}>{crew.upcomingBookings} bookings</Text>
                </Flex>
              </Flex>
              <Flex justify="space-between" className={styles.detailsRow}>
                <Flex gap={5} className="w-full">
                  <Text type="secondary" block className={styles.label}>
                    Availability:
                  </Text>
                  <Text className={styles.value}>{crew.availability || "-"}</Text>
                </Flex>
                <Flex gap={5} className="w-full">
                  <Text type="secondary" block className={styles.label}>
                    Next Time Off:
                  </Text>
                  <Text className={styles.value}>{crew.nextTimeOff || "-"}</Text>
                </Flex>
              </Flex>
            </div>
            <IconWithBg onClick={(e) => { e.stopPropagation(); openDrawerFilter(crew) }} icon={<EllipsisOutlined />} className={styles.moreBtn} />
          </Flex>
          {/* <Button type="text" icon={<EllipsisOutlined />} className={styles.moreBtn} /> */}
        </Card>
      ))}
      <CustomDrawer open={openFilterDrawer} title="Actions" setOpen={() => setOpenFilterDrawer(!openFilterDrawer)}>
        <Flex vertical gap={10} className={`w-full`}>
          <Button
            color="primary"
            variant="outlined"
            size="large"
            onClick={() => {
              setOpenFilterDrawer(false)
              handleEdit(selectedCrew)
            }}
            className={`w-full`}
          >
            <EditIcon /> {t("resources.edit") || "Edit"}
          </Button>
          {selectedCrew?.status === "active" ? (
            <Button
              color="primary"
              variant="outlined"
              size="large"
              onClick={() => {
                setOpenFilterDrawer(false)
                handleDeactivate(selectedCrew)
              }}
              className={`w-full`}
            >
              <EditIcon /> {t("resources.deactivate") || "Deactivate"}
            </Button>
          ) : (
            <Flex vertical gap={4}>
              <Button
                color="primary"
                variant="outlined"
                size="large"
                disabled={!selectedCrew?.is_password_set}
                onClick={() => {
                  setOpenFilterDrawer(false)
                  handleActivate(selectedCrew)
                }}
                className={`w-full`}
              >
                <EditIcon /> {t("resources.make_active") || "Make Active"}
              </Button>
              {!selectedCrew?.is_password_set && (
                <Text className={styles.disabledHint}>
                  {t("staff.menu_items.activate_disabled_tooltip", "This staff member will be activated automatically once they set their password")}
                </Text>
              )}
            </Flex>
          )}
          <Button
            color="danger"
            variant="outlined"
            size="large"
            onClick={() => {
              setOpenFilterDrawer(false)
              handleDelete(selectedCrew)
            }}
            className={`w-full`}
          >
            <TrashIcon /> {t("resources.delete") || "Delete"}
          </Button>
        </Flex>
      </CustomDrawer>
    </Flex>
  )
}

CrewMobileCardList.propTypes = {
  data: PropTypes.array.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleActivate: PropTypes.func.isRequired,
  handleDeactivate: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired
}

export default CrewMobileCardList
